var Dlrt;
(function (Dlrt) {
    class LocationSelectFilter {
        constructor(view) {
            this.view = view;
        }
        get View() {
            return this.view;
        }
        get Value() {
            return this.view.val();
        }
        set Value(v) {
            this.view.val(v);
        }
        hasValue() {
            return this.Value > 0;
        }
        clear() {
            this.Value = -1;
        }
    }
    Dlrt.LocationSelectFilter = LocationSelectFilter;
})(Dlrt || (Dlrt = {}));
$.fn.makeLocationSelectFilter = function () {
    return new Dlrt.LocationSelectFilter(this);
};

//# sourceMappingURL=LocationSelectFilter.js.map
